<template>
  <div class="search_input">
    <x-input
      v-model="keyWord"
      :placeholder="placeholderWord"
      @on-focus="handleFocus"
      @keyup.enter.native="enter"
      >
      <!-- 查询类型选择框，不传递typeList或typeList为空则不显示 -->
      <div class="select-wrap" slot="label" v-if="typeList.length" @click="optionShow=!optionShow">
        <div class="option-wrap" v-if="optionShow">
          <div class="select-option" v-for="item in typeList" :key="item.value" @click.stop="toggleSelectType(item)">{{item.title}}</div>
        </div>
        {{selectedTitle}}
        <div class="arrow-icon"></div>
      </div>
      <img :src="imgSrc" slot='right' class="search_icon" @click.stop="search"/>
    </x-input>
  </div>
</template>
<script>
import { XInput } from '@lx-frontend/cvux'

export default {
  components: { XInput },
  props: {
    value: [String, Number],
    placeholderWord: {
      type: String,
      default: '请输入搜索内容'
    },
    imgSrc: {
      type: String,
      default: require('@/stylesheets/images/icon-search.png')
    },
    typeList: {
      type: Array,
      default() {
        return [
          // { value: '', title: '' } value和title必须，可以根据需要在列表项中添加额外数据项
        ]
      }
    }
  },
  data() {
    return {
      keyWord: '',
      selectedTitle: '',
      optionShow: false
    }
  },
  created() {
    this.keyWord = this.value || ''
    if (this.typeList && this.typeList.length) {
      this.selectedTitle = this.typeList[0].title
    }
  },
  watch: {
    value (val) {
      if (val !== this.keyWord) {
        this.keyWord = val
      }
    },
    keyWord (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    search() {
      this.$emit('on-search')
    },
    handleFocus() {
      this.$emit('on-focus')
    },
    enter() {
      this.$emit('on-enter')
    },
    toggleSelectType(item) {
      this.optionShow = false
      this.selectedTitle = item.title
      this.$emit('on-type-change', item.value)
    }
  }
}

</script>
<style lang="less">
@import '../../stylesheets/base/fn';
.search_input {
  background-color: #eee;
  padding: 20/@w2 30/@w2;
  font-size: 15px;
  .radius(4/@w2);
  .weui_cell{background-color: #fff;}
  .weui_input{line-height: 50/@w2}
  .weui_cell{
    padding: 15/@w2 30/@w2;
  }
  .search_icon {
    width: 40/@w2;
    margin-bottom: -10/@w2;
    margin-left: 10/@w2;
  }

  .select-wrap {
    position: relative;
    margin-left: -10px;
    margin-right: 10px;
    border: none;
    box-sizing: border-box;
    border-radius: 3px;
    background-color: #eee;
    height: 60/@w2;
    line-height: 60/@w2;
    width: 170/@w2;
    font-size: 15px;
    padding: 0 20/@w2 0 20/@w2;
    .option-wrap {
      position: absolute;
      width: 260/@w2;
      z-index: 999;
      top: 70/@w2;
      left: 0;
      background-color: #fff;
      box-shadow: 2.7px 5.3px 13px 0px rgba(114, 114, 114, 0.7);
      border-radius: 4px;
      .select-option {
        height: 80/@w2;
        line-height: 80/@w2;
        padding-left: 20/@w2;
        &:not(:last-child)::after {
          display: block;
          margin-left: -20/@w2;
          content: '';
          width: 260/@w2;
          height: 0;
          border-bottom: 1px solid #eee;
          @media screen and (-webkit-min-device-pixel-ratio: 2) {
            transform: scaleY(0.5);
          }
        }
      }
    }
    .arrow-icon {
      position: absolute;
      margin-top: -3/@w2;
      border: none;
      border-top: 7/@w2 solid #000;
      border-left: 6/@w2 solid #eee;
      border-right: 6/@w2 solid #eee;
      border-left-color: transparent;
      border-right-color: transparent;
      right: 20/@w2;
      top: 50%;
    }
  }
}
</style>
